<template>
  <Modal :id="'cmp-multi-order-list'" @cancelled="onCancel">
    <template slot="header">Multi Orders</template>

    <template slot="body">
      <div class="contact-search">
        <div class="users-dropdown">
          <Dropdown
            :options="accountsTV"
            :selected="accountsTV.find((e) => e.value == searchModel.accountId)"
            :placeholder="'Accounts'"
            box
            deselect
            v-on:selectedChange="(e) => onFilteredDropdownChange('accounts', e)"
            :listHeight="420"
          >
          </Dropdown>
        </div>
        <div style="margin-left: 20px" class="users-dropdown">
          <Dropdown
            :options="statusList"
            :placeholder="'Status'"
            :selected="statusList.find((e) => e.text == searchModel.status)"
            box
            deselect
            v-on:selectedChange="(e) => onFilteredDropdownChange('status', e)"
            :listHeight="420"
          >
          </Dropdown>
        </div>
      </div>

      <div class="cm-multi-order-list-container">
        <NTable
          :headers="headers"
          :items="tableOrderList"
          class="multi-order-list h1 dbox1"
          :config="orderTableConfig"
          @scrollnext="onOrderTableScrollNext"
        >
          <template v-slot:item="{ item, tdcon }">
            <tr
              :class="{
                selected: selectedRow(item),
              }"
              @click="onRowClicked(item)"
            >
              <td v-bind="tdcon('order_id')">
                <span class="txtov" :title="item['order_id']">
                  {{ item["order_id"] }}
                </span>
              </td>
              <td v-bind="tdcon('order_reference')">
                <span class="txtov" :title="item['order_reference']">
                  {{ item["order_reference"] }}
                </span>
              </td>
              <td v-bind="tdcon('account_name')">
                <span class="txtov" :title="item['account_name']">
                  {{ item["account_name"] }}
                </span>
              </td>
              <td v-bind="tdcon('status')">
                <span class="txtov" :title="item['status']">
                  {{ item["status"] }}
                </span>
              </td>
              <td v-bind="tdcon('company_name')">
                <span class="txtov" :title="item['company_name']">
                  {{ item["company_name"] }}
                </span>
              </td>
              <td v-bind="tdcon('options')">
                <!-- <input
                  type="checkbox"
                  @click="(e) => onCheckboxChange(e, item)"
                  :name="'select_order'"
                  :id="'select_order'"
                  :checked="item.isChecked"
                /> -->
                <div class="ut-rowcen">
                  <div class="dt-checkbox v2 s1">
                    <input
                      :checked="
                        selectedMultiOrder.order_ids.find(
                          (e) => e == item.order_id
                        )
                      "
                      type="checkbox"
                      :name="'select_order'"
                      :id="'select_order'"
                      @click.stop="(e) => onCheckboxChange(e, item)"
                    />
                    <div class="checkmark"></div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </NTable>
      </div>

      <div style="width: 45%" class="form-group">
        <TextField
          class="m1"
          :type="'date'"
          :id="'account_date'"
          required
          :value="selectedMultiOrder.account_date"
          :placeholder="'Account Date'"
          @valuechanged="onDateChange"
        >
        </TextField>
        <div style="display: flex; flex-direction: row; align-items: center">
          <Checkbox2
            :id="'set_paid'"
            :label="$t('Set Paid')"
            :value="selectedMultiOrder.set_paid"
            :bb="'none'"
            :iStyle="style"
            :placeholder="$t('set Paid')"
            @input="(e) => onCheckboxChangePaid(e)"
          />
          <span
            style="
              text-align: center;
              padding-bottom: 2px;
              padding-left: 10px;
              color: var(--text-secondary);
            "
            >({{ $t("only_for_system_currency_string") }})</span
          >
        </div>
        <!-- @input="onCheckboxChangePaid"  -->
        <TextField
          class="m1"
          :id="'payment_date'"
          :type="'date'"
          required
          :value="selectedMultiOrder.payment_date"
          :placeholder="'Payment Date'"
          @valuechanged="onDateChange"
        >
        </TextField>
        <Dropdown
          :options="moneyAccountList"
          class="m2"
          :selected="selectedMoneyAccount"
          :placeholder="'Money Accounts'"
          v-on:selectedChange="(e) => onDropdownChange(e)"
          box
          :listHeight="250"
        >
        </Dropdown>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button v1 s6" @click="onAddMultiOrderClicked">
       {{$t('account_all_orders')}}
      </button>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as orderActionTypes from "../../store/orders/types";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import InputField from "../../../../plugins/text-field/input-field";
import Checkbox2 from "../../../../plugins/checkbox/checkbox-2";
import { waitForAnimation, subscribeSubject } from "../../../../utility";
import Modal from "../../../../dt-plugins/modal/modal";
import {
  createModalMixin,
  closeModal2Route,
  openModal2Route,
} from "../../../../dt-plugins/modal/modal.mixin";
import { async } from "rxjs/internal/scheduler/async";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import { OrderService } from "../../services/order.service";
import { distributionOrderGetters } from "../../store/orders/getters";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { createTV } from "../../../../models/text-value.model";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
export default {
  components: {
    InputField,
    Checkbox2,
    Modal,
    NTable,
  },

  mounted: async function () {
    const resData = await OrderService.getMultiOrders();

    this.accountList = resData;
    this.statusList = resData.data.statuses.map((e) => {
      return { text: e.value, value: e.textkey };
    });
    this.orderList = resData.data.orders;
    this.moneyAccountList = resData.data.money_accounts.map((e) => {
      return { text: e.money_account_name, value: e.money_account_id };
    });

    console.log(resData);
  },
  watch: {},
  data: function () {
    return {
      style: {
        "margin-top": "15px",
      },

      accountList: [],
      statusList: [],
      orderList: [],
      searchOrderList: [],
      moneyAccountList: [],
      orderTableConfig: createNTableConfig({
        scrollNextThreshold: 95,
        headerStyle: 3,
        rowHeight: 30,
        fullHeight: true,
        footer: false,
      }),
      selectedMultiOrder: {
        order_ids: [],
        account_date: "",
        set_paid: 1,
        payment_date: "",
        money_account: "",
      },
      searchModel: {
        accountId: 0,
        status: "",
      },
      selectedMoneyAccount: {},
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
      },
    };
  },
  // created: function () {
  //   this[orderActionTypes.FETCH_MULTI_ORDER_DATA]();
  // },

  computed: {
    ...mapGetterObject(storeNS, distributionOrderGetters),
    accountsTV: function () {
      return createTV(
        this.distributionOrderList?.accounts,
        "account_name",
        "account_id"
      );
    },
    hRowMarginRight: function () {
      if (this.orders.length > 380 / 28) {
        return "28px";
      }
    },

    tableOrderList: function () {
      if (this.searchModel.accountId != 0 || this.searchModel.status != "") {
        return this.searchOrderList || [];
      } else {
        return this.orderList || [];
      }
    },

    headers: function () {
      return [
        { value: "order_id", text: this.$t("Order ID") },
        { value: "order_reference", text: this.$t("Order Ref") },
        { value: "account_name", text: this.$t("Account") },
        { value: "status", text: this.$t("Status") },
        { value: "company_name", text: this.$t("Contact") },
        { value: "", text: this.$t("") },
      ];
    },
  },
  methods: {
    ...mapActions(storeNS, {
      [orderActionTypes.FETCH_MULTI_ORDER_DATA]:
        orderActionTypes.FETCH_MULTI_ORDER_DATA,
      [orderActionTypes.FETCH_FILTERED_MULTI_ORDER_DATA]:
        orderActionTypes.FETCH_FILTERED_MULTI_ORDER_DATA,
      [orderActionTypes.INSERT_MULTI_ORDER_DATA]:
        orderActionTypes.INSERT_MULTI_ORDER_DATA,
    }),
    onAddMultiOrderClicked: async function () {
      // NotificationService.showNotification({
      //     text: "Must Select a Licence Line to Create Invoice",
      //     timeout: 5000,
      //     type: "error",
      //   })

      const resData = await OrderService.processMultiOrders(
        this.selectedMultiOrder
      );
      this.$router.push({
        ...this.$route,
        query: {
          modal: "show_notification",
        },
      });
      //this[orderActionTypes.INSERT_MULTI_ORDER_DATA](this.selectedMultiOrder);
    },
    selectedRow: function (order) {
      return (
        this.selectedClickedOrder &&
        this.selectedClickedOrder["order_id"] === order["order_id"]
      );
    },
    onRowClicked: function (order) {},
    onTextFieldValueChange: function (e) {},
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    async onFilteredDropdownChange(action, data) {
      console.log(
        "SSS",
        this.searchModel.accountId,
        "::::",
        this.searchModel.status
      );

      if (action === "accounts") {
        this.searchModel.accountId = data.value;
      } else if (action === "status") {
        this.searchModel.status = data.text;
      }

      const orderData = await OrderService.filterMultAccountOrders({
        accountId: this.searchModel.accountId,
        status: this.searchModel.status,
      });
      this.searchOrderList = orderData.data.orders;
      console.log(":::::", orderData);
    },
    onDropdownChange(e) {
      this.selectedMultiOrder.money_account = e.value;
      this.selectedMoneyAccount = e;
    },
    onDateChange: function (name, value) {
      this.selectedMultiOrder[name] = value;
    },
    onOrderTableScrollNext: function (percent) {},
    onCheckboxChange: function (e, item) {
      this.selectedMultiOrder.order_ids.push(item.order_id);
      console.log(this.selectedMultiOrder);
    },
    onCheckboxChangePaid: function (e) {
      console.log(e);
      if (e.value) {
        this.selectedMultiOrder.set_paid = 1;
      } else {
        this.selectedMultiOrder.set_paid = 0;
      }
    },
  },
};
</script>

<style lang="scss" >
.cmp-multi-order-list {
  .fc2 label.fc2-label {
    min-width: 60% !important;
    width: 60% !important;
  }
  .dt-modal--body {
    thead {
      margin-left: 0;
      background: #f8f8f8;
      display: flex;
      flex-direction: column;
      border: 1px solid var(--sprt-5);
      //border-bottom: 1px solid #8e8e8e;
      border-radius: 3px;
      tr {
        display: flex;
        width: 100%;
        height: var(--ntable-rowHeight);
        min-height: var(--ntable-rowHeight);
        border-bottom: none;
        transition: 0.2s;
      }
    }
    tbody {
      margin-left: 0px;
      background: #f8f8f8;
      display: flex;
      flex-direction: column;
      border: 1px solid var(--sprt-5);
      border-top: none;
      border-radius: 3px;
      padding-bottom: 10px;
      max-height: var(--body-height);
      min-height: var(--body-height);
    }
  }

  .contact-search {
    height: 30px;
    width: 100%;
    margin: 0 !important;
    margin-bottom: 30px !important;
    .search {
      margin-right: 10px;
      width: 250px;
    }
    .users-dropdown {
      width: 250px;
    }
  }

  .cm-multi-order-list-container {
    .multi-order-list {
      --ntable-height: 300px !important;
      --tb-layout: fixed;
      tr {
        padding-left: 5px;
      }
      td:last-child,
      th:last-child {
        width: 50px !important;
      }

      td.name {
        color: black !important;
        font-weight: 800 !important;
      }
    }

    .dt-table.ind-table {
      td:nth-child(5),
      th:nth-child(5) {
        width: 50px !important;
      }
    }
  }
  .contact-search {
    display: flex;
    margin: 20px;
    // flex-direction: row;
    // justify-content: stretch;
  }
  .fc2-checkbox {
    .dt-checkbox-container {
      .dt-checkbox {
        //margin-top: 12px !important;
      }
    }
  }

  button {
    height: 2.5em;
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    border-radius: 5px;
  }
}
</style>
